document.addEventListener('DOMContentLoaded',() => {
    const customerInfomation = window.customerData;
    // アカウント連携ボタン
    const linkageButton = document.getElementById("mixi-login__submit-button");
    // mixi id 新規登録ボタン
    const registButton = document.getElementById("mixi__create-button");
    // アカウント連携ボタン押下処理
    linkageButton.addEventListener("click",async function(){
        // ID連携初期処理API送信
        window.location.href = "https://"+`${domain}`+"/mixi/login/init?mode=linkage-exists&customerId=" + customerInfomation.customerId;
    });
    // 新規登録ボタン押下処理
    registButton.addEventListener("click",async function(){
        // ID連携初期処理API送信
        window.location.href = "https://"+`${domain}`+"/mixi/login/init?mode=linkage&customerId=" + customerInfomation.customerId;
    });
});